<template>

  <router-view />
</template>

<style>
/* 取消页面边距，铺满整个屏幕 */
body,
html {
  padding: 0;
  margin: 0;
}

/* flex布局类名 */
.flex-float {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex {
  display: flex;
  align-items: center;
}

.page_content {
  box-sizing: border-box;
  display: block;
  width: 100%;
  padding: 20px;
  background: #fff;
  margin-top: 10px;
  border-radius: 5px;
}

.filter {
  box-sizing: border-box;
  display: block;
  width: 100%;
  padding: 20px;
  background: #fff;
  margin-top: 10px;
  border-radius: 5px;
}

.el-pagination {
  margin-top: 30px
}

.beian {
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    text-align: center;
    color: #bbb;
    cursor: pointer;
    text-decoration: none;
}

</style>
